
<button
    *ngIf="styleType == 'primary'"
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled"
    class="btn-{{styleType}} {{extraClass}} relative"
    [ngClass]="{'w-full': fullWidth}"
    (click)="onClick($event)"
    >
    <span [class.opacity-0]="isLoading">{{text}}</span>

    <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
</button>

<button
    *ngIf="styleType == 'primary-flat'"
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled"
    class="btn-{{styleType}} {{extraClass}} relative"
    [ngClass]="{'w-full': fullWidth}"
    (click)="onClick($event)"
    >
    <span [class.opacity-0]="isLoading">{{text}}</span>

    <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div class="w-5 h-5 border-2 border-red border-t-transparent rounded-full animate-spin"></div>
    </div>
</button>


<button
    *ngIf="styleType == 'secondary'"  
    [style]="extraStyle"
    [type]="submit ? 'submit' : 'button'"
    [disabled]="disabled"
    class="btn-{{styleType}} {{extraClass}} relative"
    [ngClass]="{'w-full': fullWidth}"
    (click)="onClick($event)"
    >
    <span [class.opacity-0]="isLoading">{{text}}</span>

    <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
</button>